import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class ReservationID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
